import { AboutIcon } from "@/components/icons/about";
import { WhyChooseUsIcon } from "@/components/icons/choosing-us";
import { ContactIcon } from "@/components/icons/contact";
import { HomeIcon } from "@/components/icons/home";
import { LanguageIcon } from "@/components/icons/language";
import { LoginIcon } from "@/components/icons/login";
import { ProjectsIcon } from "@/components/icons/project";
import { SearchIcon } from "@/components/icons/search";
import { ServicesIcon } from "@/components/icons/service";
import { TeamIcon } from "@/components/icons/team";

export const navItems = [
  {
    href: "/",
    label: "Home",
    icon: <HomeIcon animateOnHover />,
  },
  {
    href: "/about",
    label: "About Us",
    icon: <AboutIcon animateOnHover />,
  },
  {
    href: "/team",
    label: "Team",
    icon: <TeamIcon animateOnHover />,
  },
  {
    href: "/services",
    label: "Services",
    icon: <ServicesIcon animateOnHover />,
  },
  {
    href: "/projects",
    label: "Projects",
    icon: <ProjectsIcon animateOnHover />,
  },
  {
    href: "/why-choose-us",
    label: "Why Choose Us",
    icon: <WhyChooseUsIcon animateOnHover />,
  },
  {
    href: "/contact",
    label: "Contact",
    icon: <ContactIcon animateOnHover />,
  },
  // Blelow buttons
  {
    href: "/language",
    label: "Language",
    icon: <LanguageIcon animateOnHover />,
  },
  {
    href: "/search",
    label: "Search",
    icon: <SearchIcon animateOnHover />,
  },
  {
    href: "/auth/login",
    label: "Login",
    icon: <LoginIcon animateOnHover />,
  },
];
